/**
 * Determines if an element is visible in the viewport.
 *
 * @param ele The element to check.
 */
const isVisible = ele => {
	const { top, bottom } = ele.getBoundingClientRect();
	const vHeight = window.innerHeight || document.documentElement.clientHeight;
	return ( top > 0 || bottom > 0 ) && top < vHeight;
};

// export default isVisible;
